import { FormattedMessage } from 'react-intl'
import Content from '../Content'
import Footer from '../Footer'
import Header from '../Header'
import MenuMobile from '../MenuMobile'
import Button from '../../Component/Input/Button'

function Contact() {
  return (<>
    <Header />
    <Content>
      <div className='mx-auto flex flex-col gap-4 mt-12 max-w-xl px-4'>
        <h1 className='text-lg font-bold text-center'><FormattedMessage id="contact__support_title" /></h1>
        <h2 className="text-center border border-border rounded-xl py-3"><FormattedMessage id="contact__questions_title" /></h2>
        <div><FormattedMessage id="contact__questions_description" /></div>
        <Button color='primary' name="contact__snapdesk_link" onClick={() => window.open("https://www.snapdesk.info/", "_blank")} />
        <h2 className="text-center border border-border rounded-xl py-3"><FormattedMessage id="contact__email_title" /></h2>
        <div><FormattedMessage id="contact__email_description" /></div>
        <Button color='primary' name="contact__email_link" onClick={() => window.open("mailto:julie@snapdesk.info")} />
      </div>
      <div className='text-xs text-center'><FormattedMessage id="popin__upgrade_account_service_provider" /></div>

    </Content>
    <Footer />
    <MenuMobile />
  </>
  )
}

export default Contact